import React, { useState } from 'react'
import Panel from './Panel'
import { Risk } from '../model/Risk';
import { riskLevel } from './AnalyseCalc';
import { PDFDownloadLink } from '@react-pdf/renderer';
import TiAPDF from '../PDF/TiAPDF';

export interface Entity {
    name?: string;
    role?: string;
    status?: string;
    sector?: string;
}

export interface TiAData {
    entityData?: string;
    operationType?: string;
    transferDateStart?: string;
    transferDateEnd?: string;
    transferCategories?: string;
    personalCategories?: string;
    transferPurpose?: string;
    isToolTransfer: boolean;
    toolTransfer?: string;
    dataFormat?: string;
    entityName?: string;
    entityRole?: string;
    entityStatus?: string;
    entitySector?: string;
    country3pp?: string;
    lawRule?: string;
    wayOfTransfer?: string;
    knowledgeSource?: string;
    isCountryLaw: boolean;
    countryLaw?: string;
    isCountryEntity: boolean;
    countryEntity?: string;
    isCountryIndependent: boolean;
    countryIndependent?: string;
    isCountrySide: boolean;
    countrySide?: string;
    isLawCompatible: boolean;
    lawCompatible?: string;
    isDataAvailability: boolean;
    dataAvailaibility?: string;
    isDataNecessary:boolean;
    dataNecessary?: string;
    isControlTool: boolean;
    controlTool?: string;
    isWayOfProtect: boolean;
    wayOfProtect?: string;
    risks: Risk[];
    isWayOfProtection: boolean;
    wayOfProtection?: string;
    adminDecision?: string;
}

export default function TiA() {

    const [data, setData] = useState<TiAData>({
        isToolTransfer: false,
        isCountryLaw: false,
        isControlTool: false,
        isCountryEntity: false,
        isCountryIndependent: false,
        isCountrySide: false,
        isDataAvailability: false,
        isDataNecessary: false,
        isLawCompatible: false,
        isWayOfProtect: false,
        isWayOfProtection: false,
        risks: [{
            name: '',
            effect: 1,
            id: 1,
            probability: 1,
            recommendations: '',
            risk: '',
            source: '',
            wayOfDeal: '',
            weight: 1
        }]
    })

    const changeValue = (name: string, e: any) => {
        setData({
            ...data,
            [name]: e.target.value
        })
    }

    const checkValue = (field: string, e: any) => {
        setData({
            ...data,
            [field]: e.target.checked
        })
    }

    const riskName = (value: number) => {
        if(value == 1) return "Małe";
        if(value == 2) return "Średnie";
        if(value == 3) return "Duże";
        if(value == 4) return "Bardzo duże";
      }

      const changeRisk = (id: number, prop: string, e: any) => {
        const newRisk = data.risks.map(x => {
          if(x.id !== id) return x;
    
          return ({
            ...x,
            [prop]: e.target.value
          })
        })
    
        setData({...data, risks: newRisk})
      }

      const newRisk = (id: number): Risk => {
              return {
                  name: '',
                  effect: 1,
                  id: id,
                  probability: 1,
                  recommendations: '',
                  risk: '',
                  source: '',
                  wayOfDeal: '',
                  weight: 1
              }
          }

      const addNewDanger = () => {
        const newId = data.risks.reduce((a, b) => Math.max(a, b.id), 0);
        setData({...data, risks: [...data.risks, newRisk(newId + 1)]})
    }

    const document = () => {
                return (
                    <TiAPDF {...data} />
                )
              }

  return (
    <div>
        <div className='row'>
            <div className='col text-center'>
                <h3 className='text-dark-gray fw-700 ls-minus-1px'>TiA</h3>
            </div>
        </div>
        <div className='row'>
            <Panel header="1. Kontekst transferu">
                <div>
                    <label className='text-medium-gray mb-10px'>Podmiot przekazujący informacje</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.entityData} onChange={e => changeValue("entityData", e)} />
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Jakiej operacji dotyczy transfer?</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.operationType} onChange={e => changeValue("operationType", e)} />
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Data rozpoczęcia operacji</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.transferDateStart} onChange={e => changeValue("transferDateStart", e)} />
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Data zakończenia operacji</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.transferDateEnd} onChange={e => changeValue("transferDateEnd", e)} />
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Kategorie danych objęte operacją</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.transferCategories} onChange={e => changeValue("transferCategories", e)} />
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Kategorie osób których dane są transferowane</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.personalCategories} onChange={e => changeValue("personalCategories", e)} />
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Cel operacji</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.transferPurpose} onChange={e => changeValue("transferPurpose", e)} />
                </div>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isToolTransfer", e)} checked={data.isToolTransfer} />Czy operacja wykorzystuje narzędzia TiA? Jakie?</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.toolTransfer} onChange={e => changeValue("toolTransfer", e)} /> 
                    </div>
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Format danych(np.: tekst, anonimizacja)</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.dataFormat} onChange={e => changeValue("transferPurpose", e)} />
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Nazwa podmiotu</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.entityName} onChange={e => changeValue("entityName", e)} />
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Rola podmiotu</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.entityRole} onChange={e => changeValue("entityRole", e)} />
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Rodzaj podmiotu</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.entityStatus} onChange={e => changeValue("entityStatus", e)} />
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Sektor podmiotu</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.entitySector} onChange={e => changeValue("entitySector", e)} />
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Państwo, do którego transferujesz dane</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.country3pp} onChange={e => changeValue("country3pp", e)} />
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Podstawa prawna transferu danych</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.lawRule} onChange={e => changeValue("lawRule", e)} />
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Środki zabezpieczenia transferu</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.wayOfTransfer} onChange={e => changeValue("wayOfTransfer", e)} />
                </div>
            </Panel>
            
            <Panel header="2. Prawo i praktyka">
                <div>
                    <label className='text-medium-gray mb-10px'>Źródło wiedzy o systemie prawnym w kraju odbiorcy</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.knowledgeSource} onChange={e => changeValue("knowledgeSource", e)} />
                </div>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isCountryLaw", e)} checked={data.isCountryLaw} />Czy w kraju są przepisy RODO?</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.countryLaw} onChange={e => changeValue("countryLaw", e)} /> 
                    </div>
                </div>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isCountryEntity", e)} checked={data.isCountryEntity} />Czy w kraju są respektowane przepisy RODO?</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.countryEntity} onChange={e => changeValue("countryEntity", e)} /> 
                    </div>
                </div>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isCountryIndependent", e)} checked={data.isCountryIndependent} />Czy kraj posiada niezależny organ nadzorczy odnośnie RODO?</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.countryIndependent} onChange={e => changeValue("countryIndependent", e)} /> 
                    </div>
                </div>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isCountrySide", e)} checked={data.isCountrySide} />Czy kraj jest zobowiązany międzynarodowo odnośnie RODO?</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.countrySide} onChange={e => changeValue("countrySide", e)} /> 
                    </div>
                </div>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isLawCompatible", e)} checked={data.isLawCompatible} />Czy przepisy są zgodne z UE?</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.lawCompatible} onChange={e => changeValue("lawCompatible", e)} /> 
                    </div>
                </div>
            </Panel>
            <Panel header="3. Służby specjalne a dane osobowe">
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isDataAvailability", e)} checked={data.isDataAvailability} />Czy dostęp do danych jest jasny i precyzyjny?</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.dataAvailaibility} onChange={e => changeValue("dataAvailaibility", e)} /> 
                    </div>
                </div>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isDataNecessary", e)} checked={data.isDataNecessary} />Czy dostęp do danych jest niezbędny?</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.dataNecessary} onChange={e => changeValue("dataNecessary", e)} /> 
                    </div>
                </div>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isControlTool", e)} checked={data.isControlTool} />Czy istnieje kontrola nad służbami specjalnymi?</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.controlTool} onChange={e => changeValue("controlTool", e)} /> 
                    </div>
                </div>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isWayOfProtect", e)} checked={data.isWayOfProtect} />Czy istnieją środki ochrony osób?</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.wayOfProtect} onChange={e => changeValue("wayOfProtect", e)} /> 
                    </div>
                </div>
            </Panel>
            <Panel header="4. Analiza ryzyka">
                <div className='row mb-15px'>
                    <div>
                        {data.risks.map((x, i) => {
                            return (
                                <div key={x.id} className={`row mb-15px ${i !== data.risks.length - 1 ? "border-bottom border-2 border-color-gray" : ""}`}>
                                    <div className='col-lg-12'>
                                        <div className='progress-bar-style-02'>
                                            <div className='progress mb-15px border-radius-50px fw-700 fs-11 lh-11 text-white bg-white'>
                                                <div className="progress-bar bg-gradient-flamingo-red-transparent m-0 appear" role="progressbar" aria-valuenow={98} aria-valuemin={0} aria-valuemax={100} aria-label="business" style={{width: riskLevel(x).value}} />
                                                <div className="progress-bar-title text-uppercase">{riskLevel(x).text}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-5">
                                        <label className='text-medium-gray mb-10px'>Naruszenie</label>
                                        <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={x.name} onChange={e => changeRisk(x.id, "name", e)} />
                                    </div>
                                    <div className="col-lg-4">
                                        <label className="text-medium-gray">Prawdopodobieństwo - {riskName(x.probability)}</label>
                                        <input type="range" className='calc-range' min="1" max="4" step="1" value={x.probability} onChange={e => changeRisk(x.id, "probability", e)} />
                                    </div>
                                    <div className="col-lg-3">
                                        <label className="text-medium-gray">Skutki - {riskName(x.effect)}</label>
                                        <input type="range" className='calc-range' min="1" max="4" step="1" value={x.effect} onChange={e => changeRisk(x.id, "effect", e)} />
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div className="row" style={{ marginTop: "1.0rem"}}>
                        <div className="col">
                            <button type="button" className="btn btn-medium btn-dark-gray btn-box-shadow btn-round-edge text-transform-none primary-font" onClick={addNewDanger}>Dodaj</button>
                        </div>
                    </div>
                </div>
            </Panel>
            <Panel header='5. Wynik testu'>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isWayOfProtection", e)} checked={data.isWayOfProtection} />Czy odbiorca danych zapewni europejski poziom ochrony?</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.wayOfProtection} onChange={e => changeValue("wayOfProtection", e)} /> 
                    </div>
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Decyzja administratora</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.adminDecision} onChange={e => changeValue("adminDecision", e)} />
                </div>
            </Panel>
            <div className="row text-right">
                <div className='calc-pdf-btn'>
                    <PDFDownloadLink className='btn btn-medium btn-dark-gray btn-box-shadow btn-round-edge text-transform-none primary-font submit' document={document()}>Zapisz do pliku PDF</PDFDownloadLink>
                </div>
            </div>
        </div>
    </div>
  )
}